export const CustomTimer = () => {
  let value;
  let count = 60;
  const timer = setInterval(function () {
    if (count > 0) count--;

    if (count <= 0) count = 60;
  }, 1000);

  return count;
};

export const convert = (value) => JSON.parse(value);

export const truncateStr = (str, n, end = 6) => {
  return str?.length > n
    ? str.substr(0, n - 1) + "..." + str.substr(n + end, str.length - 1)
    : str;
};

export const formattedDate = (
  date,
  dateFormat = {
    day: "numeric",
    month: "short",
    year: "numeric",
  }
) => {
  const format = new Date(date);

  return format.toLocaleDateString("en-GB", dateFormat);
};
export const formattedDateWithOrdinal = (
  date,
  dateFormat = {
    day: "numeric",
    month: "short",
    year: "numeric",
  }
) => {
  const format = new Date(date);
  const day = format.getDate();
  const month = format.toLocaleString("default", { month: "short" });
  const year = format.getFullYear();

  const nthNumber = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const formatted = `${day}${nthNumber(day)} ${month}, ${year}`;
  return formatted;
};

export const formattedDateWithIntl = (date: any) => {
  const options = {
    year: "numeric",
    day: "numeric",
    month: "short",
    // hour: "numeric",
    // minute: "numeric",
    // second: "numeric",
    // hour12: true,
    // timeZone: "Nigeria/Lagos",
  };
  return new Intl.DateTimeFormat("en-US", options).format(date);
};

export const formattedTransactionDate = (
  date: any,
  dateFormat = {
    day: "numeric",
    month: "long",
    year: "numeric",
  }
) => {
  const format = new Date(date);
  return format.toLocaleDateString("en-GB", dateFormat);
};

export const formattedTime = (time: string) => {
  const format = new Date(time);
  return format.toLocaleTimeString("en-US");
};

export function formatType(date) {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export const toTitleCase = (text: string) => {
  return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
};

export function formatTimeAgo(date: Date | string): string {
  // Initialize a default date as the current date
  let _date: Date = new Date();

  // Check if the input is a string and convert it to a Date object
  if (typeof date === "string") {
    _date = new Date(date);
  } else {
    _date = date;
  }

  // Calculate the time difference in seconds
  const seconds: number = Math.floor(
    (new Date().getTime() - _date.getTime()) / 1000
  );

  // Define intervals for different time units in seconds
  const intervals: Record<string, number> = {
    year: 31536000,
    month: 2628000,
    day: 86400,
    hour: 3600,
    minute: 60,
  };

  // Iterate through the intervals and determine the appropriate unit
  for (const [unit, secondsInUnit] of Object.entries(intervals)) {
    const interval: number = Math.floor(seconds / secondsInUnit);
    if (interval > 1) {
      return `${interval} ${unit}s ago`;
    } else if (interval === 1) {
      return `${interval} ${unit} ago`;
    }
  }

  // If no larger unit is found, return "just now"
  return "just now";
}

export function formatNumber(
  number: number | string | null | undefined,
  decimalPlaces: number = 0
): string {
  if (number === null || number === undefined) return "0";

  const num = typeof number === "string" ? parseFloat(number) : number;

  if (isNaN(num)) return "";

  const fixed = num.toFixed(decimalPlaces);
  const [integerPart, decimalPart] = fixed.split(".");
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
}
